import { Box, HStack, Text } from '@chakra-ui/react'
import React from 'react'
import { Link, useMatch } from 'react-router-dom'

const SidebarLink = ({ name, path, icon, onClick, target }) => {
  if (path) {
    const selected = useMatch(path)

    return (
      <Link to={path} style={{ textDecoration: 'none' }} target={target}>
        <Box
          w="100%"
          px={5}
          py={3}
          _hover={{ bg: 'teal.600', cursor: 'pointer', color: 'white', borderRadius: '10' }}
          bg={selected ? 'teal.600' : ''}
          color={selected ? 'white' : ''}
          borderRadius={selected ? '10' : ''}
        >
          <HStack>
            {icon}
            <Text fontSize="md">{name}</Text>
          </HStack>
        </Box>
      </Link>
    )
  } else {
    const selected = ''
    return (
      <Link style={{ textDecoration: 'none' }} onClick={onClick} target={target}>
        <Box
          w="100%"
          px={5}
          py={3}
          _hover={{ bg: 'teal.600', cursor: 'pointer', color: 'white', borderRadius: '10' }}
          bg={selected ? 'teal.600' : ''}
          color={selected ? 'white' : ''}
          borderRadius={selected ? '10' : ''}
        >
          <HStack>
            {icon}
            <Text fontSize="md">{name}</Text>
          </HStack>
        </Box>
      </Link>
    )
  }
}

export default SidebarLink
